function get({ path = '/forecasts', params }) {
  return this.axios.get(path, { params })
}

const forecasts = (axios) => ({ axios, get })

export default forecasts
